var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 32,
  fill: "#F2F0EC",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.65 3.2h38.71v25.6H4.65z",
  opacity: 0.01
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F26122",
  d: "M18.9 7.66h10.21v16.68H18.9z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA1D25",
  d: "M20 16a10.58 10.58 0 0 1 4-8.34 10.61 10.61 0 1 0 0 16.68A10.58 10.58 0 0 1 20 16"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F69E1E",
  fillRule: "evenodd",
  d: "M40.14 22.23v.34h-.06v-.34h-.14v-.07h.35v.07zm.68-.07v.41h-.07v-.31l-.11.27h-.08l-.12-.27v.31h-.07v-.41h.1l.13.29.12-.29z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F69E1E",
  d: "M41.16 16A10.61 10.61 0 0 1 24 24.34c4.6-3.622 5.397-10.286 1.78-14.89A10.4 10.4 0 0 0 24 7.66 10.61 10.61 0 0 1 41.16 16"
})));
export default SvgMastercard;